var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ship" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-bottom": "20px" },
          attrs: { data: _vm.poTrackingDeliveryVo.sizeQtyMap, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: "尺码", align: "center" },
          }),
          _vm._v(" "),
          _vm._l(_vm.poTrackingDeliveryVo.sizeList, function (item) {
            return _c(
              "el-table-column",
              {
                key: item.filedCode,
                attrs: {
                  align: "center",
                  prop: item.filedCode,
                  label: item.filedName,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row[item.filedCode])),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _c("template", { slot: "header" }, [
                  _c("span", { staticClass: "center" }, [
                    _vm._v(_vm._s(item.filedName)),
                  ]),
                ]),
              ],
              2
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }